/**
 * List-kontrakt — sdileny tvar dotazu a odpovedi pro vsechny seznamy
 * (REOS, Kokpit, Fakturace). Wire format je popsany v docs/LIST-CONTRACT.md;
 * tento modul je jeho typova a (de)serializacni implementace pro klienty.
 */
export const LIST_DEFAULT_PAGE_SIZE = 50;
export const LIST_MAX_PAGE_SIZE = 200;
/** Serializace dotazu do query stringu dle LIST-CONTRACT.md. */
export function toSearchParams(q) {
    const p = new URLSearchParams();
    p.set('page', String(q.page));
    p.set('pageSize', String(q.pageSize));
    if (q.sort && q.sort.length > 0) {
        p.set('sort', q.sort.map((s) => `${s.field}:${s.dir}`).join(','));
    }
    if (q.filters) {
        for (const [key, value] of Object.entries(q.filters)) {
            if (Array.isArray(value)) {
                for (const v of value)
                    p.append(`filter[${key}]`, v);
            }
            else {
                p.set(`filter[${key}]`, String(value));
            }
        }
    }
    if (q.search !== undefined && q.search !== '')
        p.set('search', q.search);
    return p;
}
function clampPage(raw) {
    const n = raw === null ? NaN : Number(raw);
    return Number.isInteger(n) && n >= 1 ? n : 1;
}
function clampPageSize(raw, fallback) {
    const n = raw === null ? NaN : Number(raw);
    if (!Number.isInteger(n) || n < 1)
        return fallback;
    return Math.min(n, LIST_MAX_PAGE_SIZE);
}
function parseSort(raw) {
    if (raw === null || raw === '')
        return undefined;
    const entries = raw
        .split(',')
        .map((part) => {
        const [field, dir] = part.split(':');
        if (!field || (dir !== 'asc' && dir !== 'desc'))
            return undefined;
        return { field, dir };
    })
        .filter((s) => s !== undefined);
    return entries.length > 0 ? entries : undefined;
}
/**
 * Parsovani query stringu zpet na ListQuery (roundtrip s toSearchParams).
 * Neplatne hodnoty se tise srovnaji na bezpecne meze (server je autorita).
 */
export function parseListQuery(params, defaults) {
    const filters = {};
    const arrayKeys = new Set();
    for (const key of params.keys()) {
        const m = /^filter\[(.+)\]$/.exec(key);
        if (!m || !m[1])
            continue;
        const values = params.getAll(key);
        if (values.length > 1 || arrayKeys.has(m[1])) {
            arrayKeys.add(m[1]);
            filters[m[1]] = values;
        }
        else {
            const v = values[0] ?? '';
            if (v === 'true' || v === 'false')
                filters[m[1]] = v === 'true';
            else if (v !== '' && !Number.isNaN(Number(v)))
                filters[m[1]] = Number(v);
            else
                filters[m[1]] = v;
        }
    }
    const sort = parseSort(params.get('sort'));
    const search = params.get('search');
    return {
        page: clampPage(params.get('page')),
        pageSize: clampPageSize(params.get('pageSize'), defaults?.pageSize ?? LIST_DEFAULT_PAGE_SIZE),
        ...(sort !== undefined ? { sort } : {}),
        ...(Object.keys(filters).length > 0 ? { filters } : {}),
        ...(search !== null && search !== '' ? { search } : {}),
    };
}
function csvField(raw) {
    return /[",\n\r]/.test(raw) ? `"${raw.replaceAll('"', '""')}"` : raw;
}
/**
 * Klientsky CSV export (RFC 4180, CRLF, bez BOM) — pro aktualne nactena data.
 * Plny export pres vsechny stranky dela server (format=csv), viz LIST-CONTRACT.md.
 */
export function toCsv(rows, columns) {
    const header = columns.map((c) => csvField(c.header)).join(',');
    const body = rows.map((row) => columns.map((c) => csvField(c.value(row))).join(','));
    return [header, ...body].join('\r\n');
}
//# sourceMappingURL=contract.js.map